<template>
  <v-container fluid class="locationtracking-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <!-- <v-btn to="/locationtracking/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn> -->
              <v-btn color="primary" outlined class="button-shadow">
                <v-icon class="mr-2">mdi-filter-variant</v-icon>
                Filters
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="locationtrackings-table"
              show-select
              sort-desc
              single-select
              item-key="_id"
              sort-by="dateutc"
              :footer-props="footer"
              :headers="headers"
              :items="locationtrackings"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Time Tracking?
                    </v-card-title>

                    <v-card-text>
                      {{ deletelocationtracking.locationtrackingname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletelocationtracking)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <v-avatar v-if="users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.find(user=>user._id == item.userid)['username'][0].toUpperCase() }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.find(user=>user._id == item.userid)['username'] }} </span>
              </template>
              <template v-slot:item.geolocation="{ item }">
                <a class="primaryConst--text" target="_blank" v-bind:href="'http://maps.google.com/maps?q=' + item.geolocation.replace(' ', '')">Map</a>
              </template>
              <template v-slot:item.speed="{ item }">
                {{ item.speed.substr(0,6) }}
              </template>
              <template v-slot:item.bearing="{ item }">
                {{ item.bearing.substr(0,6) }}
              </template>
              <template v-slot:item.altitude="{ item }">
                {{ item.altitude.substr(0,6) }}
              </template>
              <template v-slot:item.dateutc="{ item }">
                {{ new Date(item.dateutc).toLocaleString() }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <!-- <v-btn icon color="primary">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                <!-- <v-btn icon color="primary" @click="deleteItem(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn> -->
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LocationTrackingList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deletelocationtracking: {},
      headers: [
        { text: 'Name', value: 'userid' },
        { text: 'Time', value: 'dateutc' },
        { text: 'Geolocation', value: 'geolocation', sortable: false },
        { text: 'Speed', value: 'speed', sortable: false},
        { text: 'Bearing', value: 'bearing', sortable: false },
        { text: 'Altitude', value: 'altitude', sortable: false },
        { text: 'Create', value: 'createdAt' },
        //{ text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      locationtrackingid: ['admin', 'locationtracking'],
      editedIndex: -1,
      editedItem: {
        locationtrackingname: '',
        image: '',
        locationtrackingid: '',
        company: '',
        locationtrackingtype: '',
        locationtrackingstatus: '',
        create: '',
      },
      defaultItem: {
        locationtrackingname: '',
        image: '',
        locationtrackingid: '',
        company: '',
        locationtrackingtype: '',
        locationtrackingstatus: '',
        create: '',
      },
      
      text: '',
      //notification: '<p class="font-weight-bold mb-0">This page is only available in Vue Material Admin Full with ' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-node-js">NodeJS</a>/' +
      //    '<a rel="noreferrer noopener" target="_blank" class="white--text text-decoration-none" href="https://flatlogic.com/templates/sing-app-vue-laravel">PHP</a> backend integration!</p>'
    }
  },

  computed: {
    ...mapState('LocationTracking', ['locationtrackings', 'isReceiving', 'isDeleting', 'idToDelete', 'locationtrackingsMessage', 'isUpdating']),
    ...mapState('User', ['users']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit LocationTracking'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    locationtrackingsMessage() {
      this.notification = this.locationtrackingsMessage;
      this.addSuccessNotification()
    }
  },
  mounted(){
    if(this.users.length == 0) {
      this.getUsersRequest();
    }
    this.getLocationTrackingsRequest();
  },

  methods: {
    ...mapActions('LocationTracking', ["getLocationTrackingsRequest", "deleteLocationTrackingRequest"]),
    ...mapActions('User', ['getUsersRequest']),

    editItem(item) {
      console.log(item);
      this.$router.push({ name: 'LocationTrackingEdit', params: item })
    },

    deleteItem(item) {
      this.deleteLocationTrackingRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      console.log(item);
      this.dialog = true;
      this.deletelocationtracking = {
        _id: item._id,
        locationtrackingname: item.locationtrackingname,
      }
    },

    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
